// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"16ecec86","305":"87ee2620","311":"6fb83e83","379":"4f9d36b9","482":"d715b22a","545":"72cb311b","787":"6a5d0ee9","921":"85ed3710","975":"d1488b14","997":"8b079df4"}[chunkId] + ".chunk.js";
};